
import { Component, inject, signal, type WritableSignal } from '@angular/core';
import { Navbar } from '../../../../shared/components/navbar/navbar';
import { Card } from '../../../../shared/components/card/card/card';
import { CardHeader } from '../../../../shared/components/card/card-header/card-header';
import { TableContracts } from "../../../../shared/tables/table-contracts/table-contracts";
import { Router } from '@angular/router';
import type { Contract } from '../../../../interfaces/contract';

@Component({
  selector: 'app-contracts-list',
  imports: [
    Navbar,
    Card,
    CardHeader,
    TableContracts
],
  templateUrl: './contracts-list.html',
  styleUrl: './contracts-list.css',
})
export class ContractsList {

  private readonly _router: Router = inject(Router);

  public loading: WritableSignal<boolean> = signal<boolean>(false);

  public onContractClick(contract: Contract): void {
    this._router.navigate(['contracts', contract.id]);
  }

}
